<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modal__backdrop" @click="closeModal()"/>
      <div class="modal_container">
        <div class="modal__dialog">
          <div class="modal__header">
            <v-btn small
                   rounded
                   icon
                   color="#ff8484"
                   @click="closeModal()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="modal__body">
            <v-text-field v-model="search"
                          outlined
                          placeholder="Search a user"/>
            <v-card class="usersList">
              <v-card v-for="user in filteredList"
                      :key="user.id"
                      class="ma-1"
              >
                <div class="ml-4 pa-1">
                  <v-btn
                    width="100%"
                    elevation="0"
                    :ripple="false"
                    @click='loadUserModal(user)'>
                    {{ user.name.replaceAll("\"", "") }}
                  </v-btn>
                </div>
              </v-card>
            </v-card>
            <v-card v-if="filteredList.length === 0" class="ma-1">
              <span> No users found</span>
            </v-card>
          </div>
        </div>
        <OtherUserModal :user="selectedUser"
                        :following="following"
                        :on-create-user-follow="onCreateUserFollow"
                        :on-delete-user-follow="onDeleteUserFollow"
                        :show-rating="showRating"
                        @openSnackbar="openSnackbar"
                        ref="otherUserModal"/>
      </div>
    </div>
  </transition>
</template>

<script>
import OtherUserModal from "@/components/User/Modals/OtherUserModal";

export default {
  name: "SearchUserModal",
  components: {
    OtherUserModal
  },
  data() {
    return {
      show: false,
      search: '',
      selectedUser: "",
      following: false,
    };
  },
  computed: {
    filteredList() {
      return this.usersList.filter(user => {
        return user.name.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  props: ['usersList',
    'followingList',
    'onCreateUserFollow',
    'onDeleteUserFollow',
    'showRating'
  ],

  methods: {
    openSnackbar(payload) {
      this.$emit('openSnackbar', {message: payload.message, type: payload.type})
    },

    closeModal() {
      this.show = false;
      document.querySelector("body").classList.remove("overflow-hidden");
    },

    openModal() {
      if (this.usersList.length !== undefined) {
        this.show = true;
        document.querySelector("body").classList.add("overflow-hidden");
      }
    },

    loadUserModal(user) {
      this.selectedUser = user
      for (let followed_user of this.followingList) {
        if (followed_user.id === user.id) {
          this.following = true
          break
        } else {
          this.following = false
        }
      }
      this.$refs.otherUserModal.openModal()
    }
  },
}
</script>

<style lang="scss" scoped>
.modal {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;

  .modal_container {
    display: flex;
    justify-content: center;
    margin-top: 20vh;
    height: 60%;
  }

  &__backdrop {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  &__dialog {
    background-color: #ffffff;
    position: relative;
    width: 50vw;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    border-radius: 15px;
    z-index: 2;

    @media screen and (max-width: 992px) {
      width: 90%;
    }
  }

  &__close {
    width: 30px;
    height: 30px;
  }

  &__header {
    padding: 20px 20px 10px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  &__body {
    padding: 10px 20px 10px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  &__footer {
    padding: 10px 20px 20px;
  }

}

.fade-enter-active,
.fade-leave-active {
  transition: opacity ease-in 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.overflow-hidden2 {
  overflow: hidden;
}

</style>
